// extracted by mini-css-extract-plugin
export var noSpinners = "_nt-6";
export var percentageInput = "_nt-7";
export var variantColor1 = "_nt-0";
export var variantColor2 = "_nt-1";
export var variantColor3 = "_nt-2";
export var variantColor4 = "_nt-3";
export var variantColor5 = "_nt-4";
export var variantColor6 = "_nt-5";